import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputBlock from 'components/connectedForm/InputBlock';
import InputGroup from 'components/connectedForm/InputGroup';
import InputLabel from 'components/connectedForm/InputLabel';
import CheckboxTree from 'components/connectedForm/CheckboxTree';
import InputErrorMessage from 'components/connectedForm/InputErrorMessage';

export default class CheckboxTreeInput extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      checked: props.checked,
      expanded: [],
    };
  }

  onChange(checked) {
    if (this.props.onChange) this.props.onChange(checked);
    this.setState({ checked });
  }

  focus() {
    this.node.focus();
  }

  render() {
    const {
      active,
      id,
      label,
      includeLabel,
      flexBox,
      labelCols,
      inputCols,
      readOnly,
      mandatory,
      hint,
      nodes,
      value,
      validationErrors,
      customValidationErrors,
      showWhenNotActive,
      touched,
    } = this.props;

    const labelProps = {
      flexBox,
      id,
      includeLabel,
      hint,
      label,
      mandatory,
      readOnly,
    };
    const disabled = this.props.readOnly ? true : null;
    const control = (
      <CheckboxTree
        nodes={nodes}
        disabled={disabled}
        ref={(node) => (this.node = node)}
        checked={this.state.checked}
        expanded={this.state.expanded}
        onCheck={(checked) => this.onChange(checked)}
        onExpand={(expanded) => this.setState({ expanded })}
        {...this.props}
      />
    );
    if (this.props.inGrid) return control;
    return (
      <InputBlock flexBox={flexBox}>
        <InputLabel {...labelProps} cols={labelCols} />
        <InputGroup flexBox={flexBox} cols={includeLabel ? inputCols : 1} withLabel={includeLabel}>
          {control}
          <InputErrorMessage
            label={label}
            active={active}
            touched={touched}
            validationErrors={validationErrors}
            customValidationErrors={customValidationErrors}
            showWhenNotActive={showWhenNotActive}
          />
        </InputGroup>
      </InputBlock>
    );
  }
}

CheckboxTreeInput.propTypes = {
  active: PropTypes.bool,
  mandatory: PropTypes.bool,
  onChange: PropTypes.func,
  includeLabel: PropTypes.bool,
  readOnly: PropTypes.bool,
  flexBox: PropTypes.bool,
  labelCols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  inputCols: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.string,
  hint: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  validationErrors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  showWhenNotActive: PropTypes.bool,
  label: PropTypes.string,
  type: PropTypes.string,
};
CheckboxTreeInput.defaultProps = {
  active: false,
  mandatory: false,
  onChange: () => {},
  includeLabel: true,
  readOnly: false,
  flexBox: true,
  labelCols: 1 / 4,
  inputCols: 3 / 4,
  value: '',
  validationErrors: [],
  hint: '',
  showWhenNotActive: false,
  label: '',
  id: '',
};
